import React, { Component } from 'react';
import './Home.css';
import Navbar from './Navbar';
import logo from '../healthfy-chat.jpg';

class Chat extends Component {

	render() {
		return (
	  		<div>

	    		<Navbar />
	    		<img className="tela" src={logo} alt="logo"></img>
	  		</div>
		);
	}
}

export default Chat;


// WEBPACK FOOTER //
// ./src/components/Chat.js